module.exports = __webpack_public_path__ + "img/ctrl-circuit-stub-down--i.c6f17d8f.svg";